export default {"src":"/_next/static/media/ultra-plan.67a3d698.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};